export const SET_TAX_IDENTIFIERS = 'SET_TAX_IDENTIFIERS';
export const setTaxIdentifiers = (data) => ({
  type: SET_TAX_IDENTIFIERS,
  data,
});

export const ADD_TAX_IDENTIFIER = 'ADD_TAX_IDENTIFIER';
export const addTaxIdentifier = (newTaxData) => ({
  type: ADD_TAX_IDENTIFIER,
  newTaxData,
});
